export default {
  journey: {
    get: {
      method: 'post',
      url: '/client/monitoring/journeys'
    },
    getDetail: {
      method: 'get',
      url: '/client/monitoring/journeys/ID'
    },
    getDocuments: {
      method: 'get',
      url: '/client/monitoring/journeys/ID/document'
    },
    setActualTime: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/actual-time'
    },
    setActualTimeMultiple: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/actual-time-multiple'
    },
    setActualTimeBegin: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/actual-time/start'
    },
    setActualTimeStop: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/actual-time/stop'
    },
    setJobCompleteTime: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/job-complete-time'
    },
    updatePlanning: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/planning'
    },
    file: {
      get: {
        method: 'get',
        url: '/client/monitoring/journeys/ID/files'
      },
      upload: {
        method: 'post',
        url: '/client/monitoring/journeys/ID/files'
      }
    },
    alert: {
      get: {
        method: 'post',
        url: '/client/monitoring/journeys/ID/alerts'
      }
    },
    activities: {
      get: {
        method: 'post',
        url: '/client/monitoring/journeys/ID/activities'
      }
    },
    read: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/read'
    },
    pricing: {
      update: {
        method: 'post',
        url: '/client/monitoring/journeys/ID/prices'
      }
    },
    changeVehicle: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/change-vehicle'
    },
    changeVehicleAndMooc: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/change-vehicle-and-mooc'
    }
  },
  vehicle: {
    get: {
      method: 'post',
      url: '/client/monitoring/vehicles'
    }
  },
  alert: {
    get: {
      method: 'post',
      url: '/client/monitoring/alerts'
    },
    skip: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/alerts/ALERT_ID/skip'
    },
    scheduleSkip: {
      method: 'post',
      url: '/client/monitoring/journeys/ID/schedule-alerts/ALERT_ID/skip'
    }
  }
}
